<template>
  <!--  <div :style="{marginLeft: active === number ? '0' : `${40 * number}px`,marginTop : active === number ? '0' : `${40 * number}px`, transform: active === number ? 'rotate(0deg)' :  `rotate(${-3 * (number + 1)}deg)`}" class="profile-card">-->
  <div class="profile-card"
    :style="{ transform: index === total - 2 ? 'rotate(-4deg)' : index === total - 3 ? 'rotate(-6deg)' : 'rotate(0)', margin: index === total - 1 ? '0' : index === total - 2 ? `35px 0 0 ${0}px` : index === total - 3 ? `70px 0 0 ${0}px` : '0' }">
    <Loader v-if="!fetched && !error && !empty" />
    <small-error v-if="error" />
    <insure @close="openDialog = false" @refresh="$emit('refresh')" :id="data.id" v-if="openDialog" type="deleteNum"
      method="delete" />
    <div class="h-100 d-flex align-items-center justify-content-center" v-if="empty">no data</div>
    <div v-if="fetched" class="wrapper">
      <div class="number">
        <span class="current-number">
          <span :class="[lang === 'ar' ? 'bold-ar' : 'bold-en']">{{ data.gsm }} {{ index }}</span>
          <span class="px-1">({{ data.isMain === 1 ? 'Main' : 'Secondary' }})</span>
        </span>
        <img @click="openDialog = true" src="../../assets/icons/rabesh.svg" v-if="data.isMain !== 1" />
      </div>
      <span
        :class="[data.data.barStatus === '0' ? 'active' : data.data.barStatus === '1' ? 'de-active' : 'gray-status', 'status']">
        <span v-if="data.data.barStatus === '0'">{{ $t('profile.active') }}</span>
        <span v-else-if="data.data.barStatus === '1'">{{ $t('profile.barInOut') }}</span>
        <span v-else-if="data.data.barStatus === '2'">{{ $t('profile.barOut') }}</span>
        <span v-else-if="data.data.barStatus === '3'">{{ $t('profile.barIn') }}</span>
        <div
          :class="[data.data.barStatus === '0' ? 'green' : data.data.barStatus === '1' ? 'red' : 'gray', 'circle mx-1']">
        </div>
      </span>
      <div class="line-type" :class="lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">
        <!--        <span :class="[data.data.lineStatus === 1 ? 'active' : 'de-active', 'status']">-->
        <!--          <span>{{ data.data.lineStatus  === 1 ? 'Active' : 'Not Active' }}</span>-->
        <!--          <div :class="[data.data.lineStatus === 1 ? 'green' : 'red', 'circle mx-1']"></div>-->
        <!--        </span>-->
        {{ data.data.lineType }}
      </div>
      <div class="date my-2">
        <div class="start">
          <span :class="lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.numbersData.activationDate') }} : </span>
          <span>{{ data.data.firstActivationDate }}</span>
        </div>
        <div class="end">
          <span :class="lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.numbersData.expiryDate') }} : </span>
          <span>{{ data.data.expiryDate }}</span>
        </div>
      </div>
      <div class="item mb-1">
        <div :class="[lang === 'ar' ? 'ml-3' : 'mr-3', 'small-circle']"></div><span
          :class="lang === 'ar' ? 'medium-ar' : 'medium-en'"> PIN </span> : <span>{{ data.data.PIN }}</span>
      </div>
      <div class="item mb-1">
        <div :class="[lang === 'ar' ? 'ml-3' : 'mr-3', 'small-circle']"></div><span
          :class="lang === 'ar' ? 'medium-ar' : 'medium-en'"> PIN2 </span> : <span>{{ data.data.PIN2 }}</span>
      </div>
      <div class="item mb-1">
        <div :class="[lang === 'ar' ? 'ml-3' : 'mr-3', 'small-circle']"></div><span
          :class="lang === 'ar' ? 'medium-ar' : 'medium-en'"> PUK </span> : <span>{{ data.data.PUK }}</span>
      </div>
      <div class="item mb-1">
        <div :class="[lang === 'ar' ? 'ml-3' : 'mr-3', 'small-circle']"></div><span
          :class="lang === 'ar' ? 'medium-ar' : 'medium-en'"> PUK2 </span> : <span>{{ data.data.PUK2 }}</span>
      </div>
      <div class="payments mt-2">
        <span style="cursor: pointer" @click="$emit('clicked', { gsm: data.gsm, type: 'recent-payments' })"
          :class="lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.payments') }}</span>
        <span :class="[lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en']">{{ Number(data.data.currentBalance) -
          Number(data.data.tekremBorrowedAmount) }} {{ $t('Bundles.sp') }}</span>
      </div>
      <div class="more"></div>
    </div>
  </div>
</template>
<script>
import Loader from '../../components/LoaderBtn/Loader'
import SmallError from '../errorHandle/SmallError'
import DeleteNumberRepository from '../../repositories/DeleteNumberRepository'
import Insure from '../../components/dialogs/Insure'
import ms from '../../utils/messeging.js'
export default {
  components: { SmallError, Loader, Insure },
  props: {
    data: Object,
    fetched: Boolean,
    error: Boolean,
    index: Number,
    opacity: Number,
    total: Number,
    initialIndex: Number,
    empty: Boolean
  },
  watch: {
    fetched (val) {
    },
    index (val) {
    }
  },
  data () {
    return {
      deleteRepo: new DeleteNumberRepository(),
      lang: this.$lang,
      openDialog: false
    }
  },
  created () {
  },
  methods: {
    async handleDelete () {
      try {
        const response = await this.deleteRepo.delete(this.data.id)
        if (response.data.status === 200) {
          ms.successMessage(response.data.message)
          this.$emit('refresh')
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        ms.errorMessage('Something went wrong')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";

.active {
  color: #00DC5F
}

.de-active {
  color: #E50019;
}

.gray-status {
  color: #4B4B4B;
}

.red {
  background: #E50019 !important;
}

.green {
  background: #00DC5F !important;
}

.gray {
  background: #4B4B4B !important;
}

.profile-card {
  height: 260px;
  width: 430px;
  user-select: none;
  //background: linear-gradient(135deg, rgba(242,242,242,.8), rgba(250,250,250,.8));
  backdrop-filter: blur(20px);
  background: linear-gradient(135deg, rgba(242, 242, 242, 1), rgba(250, 250, 250, 1));
  //background: url("../../assets/images/slider-img.png");
  border-radius: 40px; //45 in design
  border: 2px solid #FFFFFF;
  box-shadow: 10px 20px 30px rgba(0, 0, 0, 0.05);
  position: relative;
  //margin: 0 auto;
}

.wrapper {
  padding: 1rem 2rem 0 2rem;
  height: 100%;
  width: 100%;
  backdrop-filter: blur(10px);
  border-radius: inherit;
}

.number {
  display: flex;
  justify-content: space-between;
}

.current-number span:first-child {
  color: $--yellow;
  font-size: 16px;
  letter-spacing: .5px;
}

.status {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
}

.circle {
  height: 9px;
  width: 9px;
  border-radius: 50%;
}

.small-circle {
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background: #1d1d1d;
}

.line-type {
  font-size: 14.5px;
  text-transform: capitalize;
}

.date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11.5px
}

.item {
  font-size: 12.5px;
  display: flex;
  align-items: center;
}

.payments {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.payments>span:first-child {
  font-size: 13px;
  text-decoration: underline;
  text-underline-offset: 1px;
}

.payments>span:last-child {
  color: $--yellow;
  font-size: 20px
}

.more {
  width: 110px;
  height: 3px;
  background: #FFFFFF;
  margin: 8px auto 0 auto;
  border-radius: 15px;
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  left: 50% !important;
  transform: translateX(-50%);
}

/*---------- responsive --------------*/
@media (max-width: 1503px) and (min-width: 1100px) {
  .profile-card {
    height: 260px;
    width: 390px;
  }
}

@media(max-width: 570px) {
  .profile-card {
    width: 400px;
  }
}

@media(max-width: 570px) {
  .profile-card {
    width: 400px;
  }
}

@media(max-width: 480px) {
  .profile-card {
    width: 380px;
    margin: 0 auto !important;
  }
}

@media(max-width: 410px) {
  .profile-card {
    width: 350px;
    height: 275px !important;
  }

  .wrapper {
    padding: 1rem 1.5rem 0 1.5rem
  }

  .date {
    display: block;
  }
}

@media(max-width: 380px) {
  .profile-card {
    width: 320px;
  }

  .wrapper {
    padding: 1rem 1rem 0 1rem
  }
}

/*-----------------------------------*/</style>
